import React, { forwardRef } from 'react';
import styled from 'styled-components';

const Main = styled.div`
    overflow-anchor: none;
`;

const Blade = styled.div`
    display: table;
    min-height: 100vh-5rem;
    width: 100%;
    &&& > div{
        display: table-cell;
        padding-bottom: 2.5rem;
        padding-top: 2.5rem;
        vertical-align: middle;

        .blade-content {
            min-height: 75vh;
            display:flex;
            flex-direction: column;
        }
    }    
`;

const BlockBlade = styled.div`
    display: block;
    min-height: 100vh-5rem;
    width: 100%
`;

type Props = {
    isBlockDisplay?: boolean;
    fullWidth: boolean;
    children?: React.ReactNode;
    id?: string;
};

const OriginationBlade = forwardRef(({
    isBlockDisplay = false,
    fullWidth,
    children = null,
    id,
}:Props, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => (
    <Main
        className="container hc-origination"
        id={id}
        ref={ref}
        as="main"
    >
        <div className="hc-blade-flow">
            {isBlockDisplay ? (
                // To display CarouselControl component from HoneyComb, we need to use block display
                <BlockBlade>
                    <div className="gutter-px">
                        <div className="row">
                            <div className={fullWidth ? 'col-12 blade-content' : 'col-12 col-lg-7'}>
                                {children}
                            </div>
                        </div>
                    </div>
                </BlockBlade>
            ) : (
                <Blade>
                    <div className="gutter-px">
                        <div className="row">
                            <div className={fullWidth ? 'col-12 blade-content' : 'col-12 col-lg-7'}>
                                {children}
                            </div>
                        </div>
                    </div>
                </Blade>
            )}
        </div>
    </Main>
));

export default OriginationBlade;
